import { I18n } from '@calendly/i18n';
import { useClose } from '@calendly/ui/components/dropdown';
import { Loader } from '@calendly/ui/components/loader';
import { OptionUI } from '@calendly/ui/components/select';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelectData } from './context';
const notFoundTextCss = "nf9ze0b";
const NotFoundText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(notFoundTextCss, props.className)} />;
});
const optionsLoaderCss = "o1u04ot8";
const OptionsLoader = forwardRef((props, ref) => <Loader ref={ref} {...props} data-testid="loader" aria-label={I18n.t('publisher.messages.loading')} className={classNames(optionsLoaderCss, props.className)} />);
export const OptionsList = ({
  isLoading,
  notFoundText,
  children
}) => {
  const {
    options,
    onChange
  } = useSelectData();
  const closeDropdown = useClose();
  const handleClick = id => {
    onChange(id);
    closeDropdown();
  };
  if (isLoading) return <OptionsLoader role="option" />;
  if (options.length === 0 && (!children || children?.length === 0)) {
    return <NotFoundText role="option">{notFoundText}</NotFoundText>;
  }
  return <>
      {options.map(({
      id,
      name,
      disabled
    }) => <OptionUI role="option" key={id} disabled={disabled} onClick={() => handleClick(id)}>
          {name}
        </OptionUI>)}
      {children}
    </>;
};

require("./options-list.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./options-list.js");